// classes
export const CLASS_NAME_ACTIVE = 'active';
export const CLASS_NAME_ANIM_IN = 'in';
export const CLASS_NAME_CHECKED = 'checked';
export const CLASS_NAME_COLLAPSED = 'collapsed';
export const CLASS_NAME_DISABLED = 'disabled';
export const CLASS_NAME_EXPANDED = 'expanded';
export const CLASS_NAME_HIDE = 'hide';
export const CLASS_NAME_LOADING = 'loading';

// interactions
export const INTERACTION_TYPES = {
  STATUS_DOT: 'status_dot',
  CONTINUE_BUTTON: 'continue_button',
  PREV_NEXT_BUTTON: 'prev_next_button',
  ARROW_KEY: 'arrow_key',
  URL_CHANGE: 'url_change',
};

// events
export const EVT_QUIZ_POSITION_WILL_CHANGE = 'quizPositionWillChange';
export const EVT_QUIZ_POSITION_DID_CHANGE = 'quizPositionDidChange';
export const EVT_QUIZ_POSITION_LOADING = 'quizPositionLoading';

export const EVT_DAILYPROBLEM_MAINBODY_EXPANDED = 'dailyproblemMainbodyExpanded';

export const EVT_MCQ_EDIT_FORM_SET_CONTEXT = 'MCQEditFormContextSet';

export const EVT_SUBSCRIPTION_SETTINGS_TRIGGER_CLICKED = 'subscriptionSettingsTriggerClicked';

export const EVT_VKEY_BASE = 'vkey';
export const EVT_VKEY_BEFORE_UPDATE = `${EVT_VKEY_BASE}.beforeupdate`;
export const EVT_VKEY_AFTER_UPDATE = `${EVT_VKEY_BASE}.afterupdate`;

// duration (ms)
export const TRANSITION_SPEED_MEDIUM = 200;

// functions
export const FUNC_NOOP = () => {};

// states
export const QUIZ_CHAPTER_INTRO_STATE = 'QUIZ_CHAPTER_INTRO_STATE';

export const CMP_RELOADING_FLAGS = {
  DISPUTES: 'reloading-disputes',
  PANE: 'reloading-pane',
};
